export const VUE_APP_DOWNLOAD_URL = process.env.VUE_APP_DOWNLOAD_URL // pc下载地址
export const VUE_APP_PUNISH_URL = process.env.VUE_APP_PUNISH_URL
export const VUE_APP_ZBY_WEB = process.env.VUE_APP_ZBY_WEB
export const WE_CHANNEL = 'ENWECLASS' // open-api 渠道名称
export const WE_APP_ID = '458fe0db28b0D97208b907a291ea16a3' // open-api 分配至渠道的app id
export const APP_SECRET = '*iTo%Eu4R#y#=Pml3X4T*Of84o_^J=X2' // open-api 加密秘钥
export default {
    VUE_APP_DOWNLOAD_URL,
    VUE_APP_ZBY_WEB,
    VUE_APP_PUNISH_URL,
    WE_CHANNEL,
    WE_APP_ID,
    APP_SECRET
}